import React from 'react';
import GlobalStyles from 'common/components/GlobalStyles';
import type { StoryModel, StorySettingsType } from 'types/story';
import { replaceUrlHostname } from 'utils/assets';

type Props = {
	fonts: StorySettingsType['fonts'];
	storycardsDomain: StoryModel['storycardsDomain'];
};

function generateFontFace({ fonts, storycardsDomain }: Props) {
	if (!fonts) return '';

	return Object.values(fonts).reduce((acc, value) => {
		if (!value || value?.fontType === 'google') return acc;

		// eslint-disable-next-line no-param-reassign
		acc += `
				@font-face {
					font-family: '${value.fontFamily}';
					font-weight: ${value.weight};
					font-style: ${value.style.replace(/['"]+/g, '').toLowerCase()};
					src: url('${replaceUrlHostname(value.url, storycardsDomain)}');
				}
			`;
		return acc;
	}, '');
}

const CustomFonts: React.FC<Props> = props => {
	return (
		<GlobalStyles
			styles={generateFontFace({
				fonts: props.fonts,
				storycardsDomain: props.storycardsDomain,
			})}
		/>
	);
};

export default CustomFonts;
